export default {
    gridContainer: {
        padding: 3,
        gap: 1.5,
        flexWrap: "nowrap",
        top: 48,
        position: "relative",
        bottom: 0,
        height: "calc(100vh - 48px)"
    },
    pageContent: {
        width: "100%",
        maxWidth: "800px"
    },
    cards: {
        display: "flex",
        flexDirection: "column",
        gap: 2
    },
    docsCaption: {
        display: "block",
        mt: 2.5,
        color: "greyscale.700"
    }
};
